// removed by extract-text-webpack-plugin
module.exports = {"phone":"_3pDwgo0WgGBP556skg1fZk","reveal":"_3lmiO7SjDHvevss4iZF3X4"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/pages/Home/style.css
 ** module id = 596
 ** module chunks = 0
 **/